import React from "react";
import PropTypes from "prop-types";
import { Button, ButtonGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { Flag } from "..";
import { Creators as actionLanguage } from '../../store/ducks/language'

const languages = ['en-us', 'es-es', 'pt-br'];

function FlagChoice(props) {
    const dispatch = useDispatch();
    const lang  = useSelector(state => state.language.name);

    const { size } = props;

    const choiceLanguage = (locale) => () => {
        dispatch(actionLanguage.change(locale))
    }
    
    return (
        <ButtonGroup>
            { 
                languages.map((locale, index) => {
                    return <Button key={index} onClick={choiceLanguage(locale)}>
                                <Flag 
                                    style={locale === lang ? {opacity: 1} : {opacity: 0.4} }
                                    locale={locale} size={size} 
                                />
                            </Button>
                })
            }
        </ButtonGroup>
    )
}

FlagChoice.propTypes = {
    size: PropTypes.number,
};
export default FlagChoice;
